import styled from "styled-components";

export const DetailScheduleUnmarkModalContainer = styled.div<{
  isMobile?: boolean;
}>`
  border-radius: 8px;
  justify-content: center;
  text-align: center;
  align-items: center;
  align-self: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: ${(props) => (props.isMobile ? "300px" : "400px")};
  max-width: 90vw;

  background-color: #ffffff;
`;

export const DetailScheduleUnmarkModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const DetailScheduleModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
`;

export const DetailScheduleModalButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
`;
